export default {"src":"/_next/static/media/calendar_today.38de308f.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};